import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-pin-filled",
  "use": "icon-pin-filled-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 15\" id=\"icon-pin-filled\"><path d=\"M9.753 8.836c.412 2.31.187 4-.959 5.02l-.38.338-.361-.359-1.507-1.514c-.7-.704-1.401-1.407-2.103-2.11a1388.431 1388.431 0 01-3.59-3.557l-.355-.36.335-.38c1.025-1.159 2.74-1.431 4.965-1.04L9.29.127l.446.452 2.161 2.192 2.583 2.563-4.726 3.501z\" fill=\"currentColor\" /><path d=\"M.869 14.546l-.767-.765 3.96-3.974.767.764-3.96 3.975z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol